<app-entity-mat-dialog-title *ngIf="dialogRef" title="Studio Working Hours"></app-entity-mat-dialog-title>
<div [class.mat-dialog-content]="dialogRef">
    <mat-progress-spinner class="mx-auto my-3" *ngIf="showProgressSpinner" mode="indeterminate"></mat-progress-spinner>

    <form [formGroup]="studioWorkingHoursForm" *ngIf="!showProgressSpinner">
      <app-success-message [message]=this.successMessage></app-success-message>
      <app-error-message [message]=this.errorMessage></app-error-message>

      <!-- One row per day: open toggle, hours, and a menu to copy or reset -->
      <div formArrayName="field_studio_working_hours">
        <div *ngFor="let workingHour of workingHours.controls; let i = index"
             [formGroupName]="i"
             class="wh-row d-flex flex-wrap align-items-center column-gap-3 row-gap-1 py-2 border-bottom">

          <span class="wh-day fw-semibold">{{ days[workingHour.get('day').value] }}</span>

          <mat-slide-toggle class="wh-toggle" color="primary"
                            [checked]="!workingHour.get('closed').value"
                            (change)="setClosed(workingHour, !$event.checked)">
            {{ workingHour.get('closed').value ? 'Closed' : 'Open' }}
          </mat-slide-toggle>

          <div class="wh-times d-flex align-items-center gap-2">
            <span *ngIf="workingHour.get('closed').value" class="text-muted">Closed all day</span>
            <ng-container *ngIf="!workingHour.get('closed').value">
              <mat-form-field appearance="outline" class="wh-time-field" hideRequiredMarker>
                <mat-label>Opens</mat-label>
                <mat-select [formControlName]="'starthours'">
                  <mat-optgroup label="Morning">
                    <mat-option *ngFor="let hour of getHourRange(0, 48)" [value]="hour">
                      {{ convertTo12HourFormat(hour) }}
                    </mat-option>
                  </mat-optgroup>
                  <mat-optgroup label="Afternoon/Evening">
                    <mat-option *ngFor="let hour of getHourRange(48, 96)" [value]="hour">
                      {{ convertTo12HourFormat(hour) }}
                    </mat-option>
                  </mat-optgroup>
                </mat-select>
              </mat-form-field>

              <span class="text-muted">&ndash;</span>

              <mat-form-field appearance="outline" class="wh-time-field" hideRequiredMarker>
                <mat-label>Closes</mat-label>
                <mat-select [formControlName]="'endhours'">
                  <mat-optgroup label="Morning">
                    <mat-option *ngFor="let hour of getHourRange(0, 48)" [value]="hour">
                      {{ convertTo12HourFormat(hour) }}
                    </mat-option>
                  </mat-optgroup>
                  <mat-optgroup label="Afternoon/Evening">
                    <mat-option *ngFor="let hour of getHourRange(48, 96)" [value]="hour">
                      {{ convertTo12HourFormat(hour) }}
                    </mat-option>
                  </mat-optgroup>
                </mat-select>
              </mat-form-field>
            </ng-container>
          </div>

          <button mat-icon-button type="button" class="wh-action-btn ms-auto ms-md-0"
                  [matMenuTriggerFor]="dayMenu" [matMenuTriggerData]="{ index: i }"
                  [attr.aria-label]="days[workingHour.get('day').value] + ' options'">
            <mat-icon>more_vert</mat-icon>
          </button>

          <input type="hidden" formControlName="comment">
          <input type="hidden" formControlName="day">
          <input type="hidden" formControlName="day_delta">
          <input type="hidden" formControlName="all_day">
        </div>
      </div>

      <mat-menu #dayMenu="matMenu">
        <ng-template matMenuContent let-index="index">
          <button mat-menu-item type="button" (click)="copyToDays(index, allDays)">
            <mat-icon>content_copy</mat-icon>
            <span>Copy to all days</span>
          </button>
          <button mat-menu-item type="button" (click)="copyToDays(index, weekdays)">
            <mat-icon>work_outline</mat-icon>
            <span>Copy to weekdays</span>
          </button>
          <button mat-menu-item type="button" (click)="resetRow(index)">
            <mat-icon>restart_alt</mat-icon>
            <span>Reset to 1:00 PM &ndash; 10:00 PM</span>
          </button>
        </ng-template>
      </mat-menu>

      <p class="small text-muted mt-3 mb-0">
        Times are set in 15-minute increments. Use a day's menu to copy its hours to other days.
      </p>
    </form>
</div>

<mat-dialog-actions *ngIf="dialogRef" align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary"
          [disabled]="!studioWorkingHoursForm.valid || showProgressSpinner"
          (click)="actionType === 'create' ? saveStudioWorkingHours() : updateStudioWorkingHours()">
    <mat-spinner *ngIf="showProgressSpinner" diameter="20" class="d-inline-block"></mat-spinner>
    <span *ngIf="!showProgressSpinner">{{ actionType === 'create' ? 'Save Hours' : 'Update Hours' }}</span>
  </button>
</mat-dialog-actions>

<div *ngIf="!dialogRef" class="d-flex justify-content-end mt-3">
  <button mat-raised-button color="primary"
          [disabled]="!studioWorkingHoursForm.valid || showProgressSpinner"
          (click)="actionType === 'create' ? saveStudioWorkingHours() : updateStudioWorkingHours()">
    <mat-spinner *ngIf="showProgressSpinner" diameter="20" class="d-inline-block"></mat-spinner>
    <span *ngIf="!showProgressSpinner">{{ actionType === 'create' ? 'Save Hours' : 'Update Hours' }}</span>
  </button>
</div>
